(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  (() => {
    const panelOf = () => document.querySelector('[data-cart-drawer]');

    const updateCount = (count) => {
      document.querySelectorAll('[data-cart-open]').forEach((link) => {
        if (link.hasAttribute('data-cart-count')) {
          link.textContent = String(count);
          return;
        }
        const label = link.getAttribute('data-cart-label');
        if (label) link.textContent = label.replace('__COUNT__', String(count));
      });
    };

    const openCart = () => {
      const panel = panelOf();
      if (!panel) return;
      panel.classList.add('is-shown');
      panel.setAttribute('aria-hidden', 'false');
      panel.removeAttribute('inert');
      document.querySelectorAll('[data-cart-open]').forEach((link) => {
        link.setAttribute('aria-expanded', 'true');
      });
      panel.querySelector('[data-cart-close]')?.focus();
    };

    const applySection = (html) => {
      const panel = panelOf();
      if (!panel || !html) return;
      const parsed = new DOMParser().parseFromString(html, 'text/html');
      const next = parsed.querySelector('[data-cart-drawer]');
      if (!next) return;
      const open = panel.classList.contains('is-shown');
      panel.innerHTML = next.innerHTML;
      panel.dataset.itemCount = next.dataset.itemCount || '0';
      updateCount(panel.dataset.itemCount);
      if (open) openCart();
    };

    const refresh = (sections) => {
      const panel = panelOf();
      if (!panel) return Promise.resolve();
      const id = panel.dataset.sectionId;
      if (sections && sections[id]) {
        applySection(sections[id]);
        return Promise.resolve();
      }
      return fetch(window.Shopify.routes.root + '?section_id=' + id)
        .then((response) => response.text())
        .then(applySection);
    };

    const postCart = (path, body) => {
      const panel = panelOf();
      if (!panel || panel.dataset.loading === 'true') return Promise.resolve({ ok: false });
      panel.dataset.loading = 'true';
      const id = panel.dataset.sectionId;
      return fetch(window.Shopify.routes.root + path, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(Object.assign({ sections: id }, body))
      })
        .then((response) => response.json().then((data) => ({ ok: response.ok, data })))
        .then(({ ok, data }) => {
          if (!ok) return { ok, data };
          return refresh(data.sections).then(() => ({ ok, data }));
        })
        .finally(() => {
          const current = panelOf();
          if (current) delete current.dataset.loading;
        });
    };

    document.addEventListener('click', (event) => {
      const opener = event.target.closest('[data-cart-open]');
      if (opener) {
        event.preventDefault();
        openCart();
        return;
      }

      const closer = event.target.closest('[data-cart-close]');
      if (closer) {
        const panel = panelOf();
        if (!panel) return;
        panel.classList.remove('is-shown');
        panel.setAttribute('aria-hidden', 'true');
        panel.setAttribute('inert', '');
        document.querySelectorAll('[data-cart-open]').forEach((link) => {
          link.setAttribute('aria-expanded', 'false');
        });
        return;
      }

      const change = event.target.closest('[data-qty-change]');
      if (!change || change.disabled) return;
      const quantity = Number(change.getAttribute('data-qty-change'));
      if (Number.isNaN(quantity) || quantity < 0) return;
      postCart('cart/change.js', { id: change.dataset.line, quantity });
    });

    document.addEventListener('submit', (event) => {
      const form = event.target;
      if (!(form instanceof HTMLFormElement)) return;

      const action = form.getAttribute('action') || '';
      if (!/\/cart\/add/.test(action)) return;
      event.preventDefault();
      const data = new FormData(form);
      const id = data.get('id');
      const quantity = Number(data.get('quantity') || 1);
      if (!id) return;
      postCart('cart/add.js', { items: [{ id: Number(id), quantity }] }).then(({ ok }) => {
        if (ok) openCart();
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  document.querySelectorAll('[data-collection-page]').forEach((page) => {
    if (page.dataset.viewReady === 'true') return;
    page.dataset.viewReady = 'true';

    const filterButton = page.querySelector('[data-filter-toggle]');
    const filterPanel = page.querySelector('[data-filter-panel]');

    if (filterButton && filterPanel) {
      filterButton.addEventListener('click', () => {
        const open = filterButton.getAttribute('aria-expanded') !== 'true';
        filterButton.setAttribute('aria-expanded', open ? 'true' : 'false');
        filterPanel.classList.toggle('is-open', open);
      });
    }

    const grid = page.querySelector('[data-collection-grid]');
    const buttons = page.querySelectorAll('[data-view]');
    if (!grid) return;

    let queued = grid.getAttribute('data-view');
    let phase = 'idle';
    let timer = 0;

    const applyView = (view) => {
      grid.setAttribute('data-view', view);
      buttons.forEach((item) => {
        item.setAttribute('aria-pressed', item.getAttribute('data-view') === view ? 'true' : 'false');
      });
    };

    const finishFadeIn = () => {
      if (phase !== 'in') return;
      window.clearTimeout(timer);
      phase = 'idle';
      if (queued !== grid.getAttribute('data-view')) startFadeOut();
    };

    const finishFadeOut = () => {
      if (phase !== 'out') return;
      window.clearTimeout(timer);
      applyView(queued);
      phase = 'in';
      grid.classList.remove('is-fading');
      timer = window.setTimeout(finishFadeIn, 400);
    };

    const startFadeOut = () => {
      phase = 'out';
      window.clearTimeout(timer);
      grid.classList.add('is-fading');
      timer = window.setTimeout(finishFadeOut, 400);
    };

    grid.addEventListener('transitionend', (event) => {
      if (event.target !== grid || event.propertyName !== 'opacity') return;
      if (phase === 'out') finishFadeOut();
      else if (phase === 'in') finishFadeIn();
    });

    buttons.forEach((button) => {
      button.addEventListener('click', () => {
        const view = button.getAttribute('data-view');
        if (!view) return;
        const current = phase === 'idle' ? grid.getAttribute('data-view') : queued;
        if (view === current) return;

        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          window.clearTimeout(timer);
          queued = view;
          phase = 'idle';
          grid.classList.remove('is-fading');
          applyView(view);
          return;
        }

        queued = view;
        if (phase === 'idle') startFadeOut();
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (() => {
    const header = document.querySelector('[data-site-header]');
    if (!header || header.dataset.ready === 'true') return;
    header.dataset.ready = 'true';

    const inHeader = (node) => !!node.closest?.('.shopify-section-group-header-group');

    const setScrolled = () => {
      header.classList.toggle('is-scrolled', window.scrollY > 8);
    };

    const closeAll = () => {
      header.classList.remove('is-open');
      header.dataset.openMenu = '';
      header.querySelectorAll('[data-menu-toggle]').forEach((button) => {
        button.setAttribute('aria-expanded', 'false');
      });
      document.querySelectorAll('[data-menu-panel]').forEach((panel) => {
        if (panel.classList.contains('site-header__drawer')) {
          panel.hidden = true;
        } else {
          panel.classList.remove('is-shown');
        }
      });
      document.documentElement.classList.remove('menu-open');
      document.querySelectorAll('[data-cart-drawer]').forEach((drawer) => {
        drawer.classList.remove('is-shown');
        drawer.setAttribute('aria-hidden', 'true');
        drawer.setAttribute('inert', '');
      });
      document.querySelectorAll('[data-cart-open]').forEach((link) => {
        link.setAttribute('aria-expanded', 'false');
      });
    };

    const drawerLinks = header.querySelector('[data-drawer-links]');
    const drawerVisit = header.querySelector('[data-drawer-visit]');
    const drawerMenuAllowed = (node) => {
      const source = node.closest('[data-drawer-source]');
      const menu = source && source.dataset.drawerMenu;
      if (!menu) return true;
      const key = 'show' + menu.charAt(0).toUpperCase() + menu.slice(1);
      return header.dataset[key] !== 'false';
    };

    if (drawerLinks) {
      const playLink = document.querySelector('[data-drawer-source] [data-landing-play]');
      if (playLink && drawerMenuAllowed(playLink)) drawerLinks.appendChild(playLink.cloneNode(true));
      document.querySelectorAll('[data-drawer-source] [data-drawer-group]').forEach((group) => {
        if (!drawerMenuAllowed(group)) return;
        drawerLinks.appendChild(group.cloneNode(true));
      });
      if (drawerVisit) drawerLinks.appendChild(drawerVisit);
      document.querySelectorAll('[data-drawer-source] [data-drawer-link]:not([data-landing-play])').forEach((link) => {
        if (!drawerMenuAllowed(link)) return;
        drawerLinks.appendChild(link.cloneNode(true));
      });

      const setGroup = (group, open) => {
        group.classList.toggle('is-open', open);
        group.querySelector('[data-drawer-toggle]')?.setAttribute('aria-expanded', open ? 'true' : 'false');
      };

      drawerLinks.querySelectorAll('[data-drawer-toggle]').forEach((button) => {
        button.addEventListener('click', () => {
          const group = button.closest('[data-drawer-group]');
          const willOpen = !group.classList.contains('is-open');
          drawerLinks.querySelectorAll('[data-drawer-group]').forEach((other) => {
            setGroup(other, other === group && willOpen);
          });
        });
      });
    }

    header.querySelector('.site-header__drawer')?.addEventListener('click', (event) => {
      if (event.target.closest('a, [data-landing-play]')) closeAll();
    });

    header.querySelectorAll('[data-landing-play]').forEach((button) => {
      button.addEventListener('click', closeAll);
    });

    const menuName = (id) => {
      if (!id) return '';
      if (id.indexOf('HeaderShop') === 0) return 'shop';
      if (id.indexOf('HeaderCollections') === 0) return 'collections';
      if (id.indexOf('HeaderInfo') === 0) return 'info';
      if (id.indexOf('HeaderSearch') === 0) return 'search';
      if (id.indexOf('HeaderDrawer') === 0) return 'drawer';
      return '';
    };

    setScrolled();
    window.addEventListener('scroll', setScrolled, { passive: true });

    header.querySelectorAll('[data-menu-toggle]').forEach((button) => {
      button.addEventListener('click', () => {
        const panel = document.getElementById(button.getAttribute('aria-controls'));
        const willOpen = button.getAttribute('aria-expanded') !== 'true';
        closeAll();
        if (willOpen && panel) {
          button.setAttribute('aria-expanded', 'true');
          if (panel.classList.contains('site-header__drawer')) {
            panel.hidden = false;
          } else {
            panel.classList.add('is-shown');
          }
          header.classList.add('is-open');
          header.dataset.openMenu = menuName(panel.id);
          if (panel.id.indexOf('HeaderDrawer') === 0) {
            document.documentElement.classList.add('menu-open');
          }
          if (panel.id.indexOf('HeaderSearch') === 0) {
            const focusField = () => {
              if (!panel.classList.contains('is-shown')) return;
              const field = panel.querySelector('[name="q"]');
              if (!field) return;
              if (getComputedStyle(panel).visibility === 'hidden') {
                window.requestAnimationFrame(focusField);
                return;
              }
              field.focus({ preventScroll: true });
            };
            window.requestAnimationFrame(focusField);
          }
        }
      });
    });

    document.querySelectorAll('.shopify-section-group-header-group a').forEach((link) => {
      link.addEventListener('click', closeAll);
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') closeAll();
    });

    document.addEventListener('click', (event) => {
      if (!inHeader(event.target)) closeAll();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const card = document.querySelector('.hero-signup');
    const close = card?.querySelector('[data-hero-signup-close]');
    if (!card || !close || card.dataset.ready === 'true') return;
    card.dataset.ready = 'true';
    close.addEventListener('click', () => {
      card.hidden = true;
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["landing"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const landing = document.querySelector('[data-landing]');
    if (!landing || landing.dataset.ready === 'true') return;
    landing.dataset.ready = 'true';

    const scoop = landing.querySelector('[data-scoop]');
    const finePointer = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

    if (scoop && finePointer) {
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const easing = reduce ? 1 : 0.22;
      let targetX = 0;
      let targetY = 0;
      let currentX = 0;
      let currentY = 0;
      let hasPosition = false;
      let frame = null;

      const render = () => {
        currentX += (targetX - currentX) * easing;
        currentY += (targetY - currentY) * easing;
        scoop.style.setProperty('--pointer-x', `${currentX}px`);
        scoop.style.setProperty('--pointer-y', `${currentY}px`);
        const moving = Math.abs(targetX - currentX) > 0.1 || Math.abs(targetY - currentY) > 0.1;
        frame = moving ? window.requestAnimationFrame(render) : null;
      };

      document.addEventListener('pointermove', (event) => {
        if (!document.documentElement.classList.contains('landing-open') || landing.classList.contains('is-complete') || event.pointerType === 'touch') return;
        targetX = event.clientX;
        targetY = event.clientY;
        if (!hasPosition) {
          currentX = targetX;
          currentY = targetY;
          hasPosition = true;
        }
        scoop.classList.add('is-visible');
        if (frame === null) frame = window.requestAnimationFrame(render);
      });

      document.addEventListener('pointerdown', (event) => {
        if (!document.documentElement.classList.contains('landing-open') || landing.classList.contains('is-complete') || event.pointerType === 'touch' || reduce) return;
        scoop.classList.remove('is-scooping');
        void scoop.offsetWidth;
        scoop.classList.add('is-scooping');
      });

      scoop.addEventListener('animationend', () => {
        scoop.classList.remove('is-scooping');
      });
    }

    const close = () => {
      pauseMusic();
      document.documentElement.classList.remove('landing-open');
      document.documentElement.classList.add('landing-dismissed');
      scoop?.classList.remove('is-visible');
      landing.hidden = true;
      const card = document.querySelector('.hero-signup');
      if (!card) return;
      card.hidden = false;
      card.style.animation = 'none';
      void card.offsetWidth;
      card.style.animation = '';
    };

    let leaveToken = 0;
    let restartToken = 0;

    const leave = () => {
      if (landing.classList.contains('is-leaving') || landing.hidden) return;
      restartToken += 1;
      pauseMusic();
      if (landing.dataset.display !== 'reload') localStorage.setItem('bonhem-landing', '1');
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        close();
        return;
      }
      const token = ++leaveToken;
      landing.classList.add('is-leaving');
      landing.addEventListener('transitionend', (event) => {
        if (token !== leaveToken || event.propertyName !== 'opacity') return;
        close();
      });
    };

    const bag = landing.querySelector('.landing__bag');
    const bagContents = bag?.querySelector('[data-bag-contents]');
    const bagPositions = [
      { x: 30, y: 74, rotation: -14 },
      { x: 52, y: 71, rotation: 10 },
      { x: 73, y: 75, rotation: -6 },
      { x: 38, y: 53, rotation: 12 },
      { x: 63, y: 52, rotation: -10 },
      { x: 25, y: 34, rotation: 8 },
      { x: 50, y: 32, rotation: -5 },
      { x: 75, y: 35, rotation: 14 }
    ];
    const bagTimers = new Set();
    let round = 0;
    let receiveTimer = null;

    const later = (callback, delay) => {
      const timer = window.setTimeout(() => {
        bagTimers.delete(timer);
        callback();
      }, delay);
      bagTimers.add(timer);
      return timer;
    };

    const clearBagTimers = () => {
      bagTimers.forEach((timer) => window.clearTimeout(timer));
      bagTimers.clear();
      receiveTimer = null;
    };

    const placeInBag = (candy, reduce) => {
      const image = candy.querySelector('img');
      if (!image || !bagContents) return;
      const position = bagPositions[bagContents.children.length % bagPositions.length];
      const copy = image.cloneNode(true);
      copy.className = 'landing__bag-candy';
      copy.alt = '';
      copy.style.setProperty('--bag-x', `${position.x}%`);
      copy.style.setProperty('--bag-y', `${position.y}%`);
      copy.style.setProperty('--bag-rotation', `${position.rotation}deg`);
      copy.style.zIndex = String(bagContents.children.length + 1);
      if (reduce) {
        copy.style.animation = 'none';
        copy.style.opacity = '1';
        copy.style.transform = `translate(-50%, -50%) rotate(${position.rotation}deg)`;
      }
      bagContents.appendChild(copy);
    };

    const catchBag = () => {
      if (!bag) return;
      bag.classList.remove('is-anticipating', 'is-receiving');
      void bag.offsetWidth;
      bag.classList.add('is-receiving');
      if (receiveTimer) {
        window.clearTimeout(receiveTimer);
        bagTimers.delete(receiveTimer);
      }
      receiveTimer = later(() => {
        receiveTimer = null;
        bag.classList.remove('is-receiving');
      }, 760);
    };

    const resetCandies = () => {
      round += 1;
      clearBagTimers();
      bag?.classList.remove('is-anticipating', 'is-receiving');
      if (bagContents) bagContents.replaceChildren();
      landing.querySelectorAll('[data-candy]').forEach((candy) => {
        candy.classList.remove('is-caught', 'is-bagged');
        candy.style.transform = '';
        candy.style.opacity = '';
        candy.style.transition = '';
        candy.style.animation = '';
        candy.style.visibility = '';
      });
    };

    const completion = landing.querySelector('[data-landing-completion]');
    const signup = landing.querySelector('[data-landing-signup]');
    let completionShown = false;
    let experienceResetting = false;

    const clearEnding = () => {
      completionShown = false;
      experienceResetting = false;
      landing.classList.remove('is-complete', 'is-resetting');
      completion?.classList.remove('is-visible');
      completion?.setAttribute('hidden', '');
      completion?.removeAttribute('aria-hidden');
      signup?.classList.remove('is-visible');
      signup?.setAttribute('hidden', '');
      signup?.removeAttribute('aria-hidden');
      completion?.getAnimations().forEach((animation) => animation.cancel());
      signup?.getAnimations().forEach((animation) => animation.cancel());
    };

    const showCompletion = () => {
      if (completionShown || landing.classList.contains('is-leaving') || landing.hidden) return;
      completionShown = true;
      landing.classList.remove('is-resetting');
      landing.classList.add('is-complete');
      scoop?.classList.remove('is-visible', 'is-scooping');
      completion?.removeAttribute('hidden');
      completion?.removeAttribute('aria-hidden');
      completion?.classList.add('is-visible');
      signup?.removeAttribute('hidden');
      signup?.removeAttribute('aria-hidden');
      signup?.classList.add('is-visible');
    };

    const fadeOut = (element, keyframes, options) => {
      if (!element?.animate) return Promise.resolve();
      return element.animate(keyframes, options).finished.catch(() => {});
    };

    const restart = async () => {
      if (!completionShown || experienceResetting || landing.classList.contains('is-leaving') || landing.hidden) return;
      experienceResetting = true;
      const token = ++restartToken;
      round += 1;
      clearBagTimers();
      const signupStyle = signup ? getComputedStyle(signup) : null;
      const signupOpacity = signupStyle ? Number.parseFloat(signupStyle.opacity) || 0 : 0;
      const signupTransform = signupStyle && signupStyle.transform !== 'none' ? signupStyle.transform : 'translate3d(0, 0, 0)';
      const signupHeight = signup ? signup.getBoundingClientRect().height : 0;
      const signupExitsUp = window.matchMedia('(max-width: 760px)').matches;
      const signupExitY = (signupHeight + (signupExitsUp ? 32 : 40)) * (signupExitsUp ? -1 : 1);
      const completionOpacity = completion ? Number.parseFloat(getComputedStyle(completion).opacity) || 1 : 1;
      landing.classList.add('is-resetting');
      completion?.setAttribute('aria-hidden', 'true');
      signup?.classList.remove('is-visible');
      signup?.setAttribute('aria-hidden', 'true');
      signup?.querySelector('form')?.reset();

      if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        await Promise.all([
          fadeOut(completion, [{ opacity: completionOpacity }, { opacity: 0 }], {
            duration: 400,
            easing: 'ease-in',
            fill: 'forwards'
          }),
          fadeOut(signup, [
            { opacity: signupOpacity, transform: signupTransform },
            { opacity: 0, transform: `translate3d(0, ${signupExitY}px, 0)` }
          ], {
            duration: 650,
            easing: 'cubic-bezier(.4, 0, .8, .2)',
            fill: 'forwards'
          })
        ]);
      }

      if (token !== restartToken) return;
      clearEnding();
      resetCandies();
    };

    const finishIfDone = () => {
      if (landing.querySelector('[data-candy]:not(.is-bagged)')) return;
      showCompletion();
    };

    const collect = (candy) => {
      if (candy.classList.contains('is-caught') || landing.classList.contains('is-leaving') || landing.classList.contains('is-complete') || landing.classList.contains('is-resetting') || landing.hidden) return;
      candy.classList.add('is-caught');
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const collectionRound = round;
      if (reduce || !bag) {
        candy.classList.add('is-bagged');
        placeInBag(candy, true);
        finishIfDone();
        return;
      }

      const visual = candy.getBoundingClientRect();
      const target = bag.getBoundingClientRect();
      const dx = target.left + target.width * 0.5 - (visual.left + visual.width * 0.5);
      const dy = target.top + target.height * 0.38 - (visual.top + visual.height * 0.5);
      candy.style.animation = 'none';
      const rest = candy.getBoundingClientRect();
      const lockX = visual.left - rest.left;
      const lockY = visual.top - rest.top;
      candy.style.transform = `translate(${lockX}px, ${lockY}px)`;
      void candy.offsetWidth;
      candy.style.transition = 'transform 0.55s ease-in-out, opacity 0.55s ease-in-out';
      later(() => {
        if (collectionRound !== round) return;
        bag.classList.add('is-anticipating');
      }, 270);

      let settled = false;
      const settle = (event) => {
        if (event && event.propertyName && event.propertyName !== 'transform') return;
        if (settled) return;
        settled = true;
        candy.removeEventListener('transitionend', settle);
        if (collectionRound !== round) return;
        candy.classList.add('is-bagged');
        placeInBag(candy, false);
        catchBag();
        finishIfDone();
      };

      candy.addEventListener('transitionend', settle);
      later(settle, 700);
      window.requestAnimationFrame(() => {
        candy.style.transform = `translate(${lockX + dx}px, ${lockY + dy}px) scale(0.15)`;
        candy.style.opacity = '0';
      });
    };

    const open = () => {
      const root = document.documentElement;
      if (root.classList.contains('landing-open') && !landing.hidden && !landing.classList.contains('is-leaving')) return;
      leaveToken += 1;
      restartToken += 1;
      clearEnding();
      resetCandies();
      landing.hidden = false;
      root.classList.remove('landing-dismissed');
      root.classList.add('landing-open');
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        landing.classList.remove('is-leaving');
      } else {
        landing.classList.add('is-leaving');
        void landing.offsetWidth;
        landing.classList.remove('is-leaving');
      }
      startMusic();
    };

    const music = landing.querySelector('[data-landing-audio]');
    const musicToggle = landing.querySelector('[data-landing-music]');
    const musicLabel = musicToggle?.querySelector('.landing__music-label');
    let musicMutedByUser = false;

    const updateMusicToggle = () => {
      if (!musicToggle || !music) return;
      const isOn = !music.paused && !music.muted;
      musicToggle.classList.toggle('is-on', isOn);
      musicToggle.setAttribute('aria-pressed', String(isOn));
      const text = isOn ? musicLabel?.dataset.musicOn : musicLabel?.dataset.musicOff;
      if (!text) return;
      musicToggle.setAttribute('aria-label', text);
      if (musicLabel) musicLabel.textContent = text;
    };

    const pauseMusic = () => {
      if (!music) return;
      music.pause();
      updateMusicToggle();
    };

    const startMusic = () => {
      if (!music || musicMutedByUser) return;
      const root = document.documentElement;
      if (!root.classList.contains('landing-open') || root.classList.contains('landing-dismissed') || landing.hidden || landing.classList.contains('is-leaving')) return;
      music.muted = false;
      music.play().catch(() => {}).finally(updateMusicToggle);
    };

    musicToggle?.addEventListener('click', () => {
      if (!music) return;
      if (!music.paused && !music.muted) {
        musicMutedByUser = true;
        music.muted = true;
        updateMusicToggle();
        return;
      }
      musicMutedByUser = false;
      music.muted = false;
      music.play().catch(() => {}).finally(updateMusicToggle);
    });

    if (document.documentElement.classList.contains('landing-open') && !document.documentElement.classList.contains('landing-dismissed')) {
      startMusic();
    }

    landing.querySelector('[data-landing-close]')?.addEventListener('click', leave);
    landing.querySelector('[data-landing-shop]')?.addEventListener('click', leave);
    landing.querySelector('[data-landing-restart]')?.addEventListener('click', restart);
    bag?.addEventListener('click', restart);
    landing.querySelectorAll('[data-candy]').forEach((candy) => {
      candy.addEventListener('click', () => collect(candy));
    });

    document.addEventListener('click', (event) => {
      if (!event.target.closest('[data-landing-play]')) return;
      open();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  const root = document.querySelector('[data-product-page]');
  if (!root) return;

  const variantsNode = root.querySelector('[data-product-variants]');
  const variants = variantsNode ? JSON.parse(variantsNode.textContent) : [];
  const idInput = root.querySelector('[data-variant-id]');
  const priceEl = root.querySelector('[data-product-price]');
  const addButton = root.querySelector('[data-add-button]');
  const addLabel = root.querySelector('[data-add-label]');
  const photo = root.querySelector('[data-product-photo] img');
  const addText = root.dataset.addText;
  const soldText = root.dataset.soldText;
  const qty = root.querySelector('[data-qty-input]');

  const selectedOptions = () => {
    const options = [];
    root.querySelectorAll('[data-option-index][aria-pressed="true"]').forEach((button) => {
      options[Number(button.dataset.optionIndex) - 1] = button.dataset.optionValue;
    });
    return options;
  };

  const findVariant = (options) =>
    variants.find((variant) => options.every((value, index) => variant.options[index] === value));

  const applyVariant = (variant) => {
    if (!variant || !addButton || !addLabel) {
      if (addButton) addButton.disabled = true;
      if (addLabel) addLabel.textContent = soldText;
      return;
    }
    if (idInput) idInput.value = variant.id;
    if (priceEl) priceEl.textContent = variant.price;
    addButton.disabled = !variant.available;
    addLabel.textContent = variant.available ? addText : soldText;
    if (variant.image && photo) {
      photo.src = variant.image;
      photo.srcset = '';
    }
    const url = new URL(window.location.href);
    url.searchParams.set('variant', variant.id);
    history.replaceState({}, '', url);
  };

  root.querySelectorAll('[data-option-index]').forEach((button) => {
    button.addEventListener('click', () => {
      const index = button.dataset.optionIndex;
      root.querySelectorAll('[data-option-index="' + index + '"]').forEach((peer) => {
        const selected = peer === button;
        peer.classList.toggle('is-selected', selected);
        peer.setAttribute('aria-pressed', selected ? 'true' : 'false');
      });
      applyVariant(findVariant(selectedOptions()));
    });
  });

  root.querySelector('[data-qty-minus]')?.addEventListener('click', () => {
    if (!qty) return;
    qty.value = String(Math.max(1, Number(qty.value || 1) - 1));
  });

  root.querySelector('[data-qty-plus]')?.addEventListener('click', () => {
    if (!qty) return;
    qty.value = String(Math.max(1, Number(qty.value || 1) + 1));
  });

  qty?.addEventListener('change', () => {
    if (Number(qty.value) < 1 || Number.isNaN(Number(qty.value))) qty.value = '1';
  });

  root.querySelectorAll('[data-product-thumb]').forEach((thumb) => {
    thumb.addEventListener('click', () => {
      if (!photo || !thumb.dataset.image) return;
      photo.src = thumb.dataset.image;
      photo.srcset = '';
      root.querySelectorAll('[data-product-thumb]').forEach((item) => {
        item.setAttribute('aria-current', item === thumb ? 'true' : 'false');
      });
    });
  });

  const recs = root.querySelector('[data-product-recommendations]');
  if (recs && recs.dataset.url) {
    fetch(recs.dataset.url)
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const next = html.querySelector('[data-product-recommendations]');
        if (!next || !next.innerHTML.trim().length) return;
        recs.innerHTML = next.innerHTML;
        const viewAll = recs.querySelector('[data-view-all]');
        if (viewAll && recs.dataset.viewAll) viewAll.href = recs.dataset.viewAll;
      })
      .catch(() => {});
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search-menu"]) return;
  try {
    
  document.addEventListener('click', (event) => {
    if (!event.target.closest('[data-search-close]')) return;
    const panel = document.getElementById('HeaderSearch');
    if (!panel) return;
    panel.classList.remove('is-shown');
    document.querySelectorAll('[aria-controls="HeaderSearch"]').forEach((button) => {
      button.setAttribute('aria-expanded', 'false');
    });
    const header = document.querySelector('[data-site-header]');
    if (!header || header.dataset.openMenu !== 'search') return;
    header.classList.remove('is-open');
    header.dataset.openMenu = '';
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search"]) return;
  try {
    
  document.querySelectorAll('[data-collection-page]').forEach((page) => {
    if (page.dataset.viewReady === 'true') return;
    page.dataset.viewReady = 'true';

    const filterButton = page.querySelector('[data-filter-toggle]');
    const filterPanel = page.querySelector('[data-filter-panel]');

    if (filterButton && filterPanel) {
      filterButton.addEventListener('click', () => {
        const open = filterButton.getAttribute('aria-expanded') !== 'true';
        filterButton.setAttribute('aria-expanded', open ? 'true' : 'false');
        filterPanel.classList.toggle('is-open', open);
      });
    }

    const grid = page.querySelector('[data-collection-grid]');
    const buttons = page.querySelectorAll('[data-view]');
    if (!grid) return;

    let queued = grid.getAttribute('data-view');
    let phase = 'idle';
    let timer = 0;

    const applyView = (view) => {
      grid.setAttribute('data-view', view);
      buttons.forEach((item) => {
        item.setAttribute('aria-pressed', item.getAttribute('data-view') === view ? 'true' : 'false');
      });
    };

    const finishFadeIn = () => {
      if (phase !== 'in') return;
      window.clearTimeout(timer);
      phase = 'idle';
      if (queued !== grid.getAttribute('data-view')) startFadeOut();
    };

    const finishFadeOut = () => {
      if (phase !== 'out') return;
      window.clearTimeout(timer);
      applyView(queued);
      phase = 'in';
      grid.classList.remove('is-fading');
      timer = window.setTimeout(finishFadeIn, 400);
    };

    const startFadeOut = () => {
      phase = 'out';
      window.clearTimeout(timer);
      grid.classList.add('is-fading');
      timer = window.setTimeout(finishFadeOut, 400);
    };

    grid.addEventListener('transitionend', (event) => {
      if (event.target !== grid || event.propertyName !== 'opacity') return;
      if (phase === 'out') finishFadeOut();
      else if (phase === 'in') finishFadeIn();
    });

    buttons.forEach((button) => {
      button.addEventListener('click', () => {
        const view = button.getAttribute('data-view');
        if (!view) return;
        const current = phase === 'idle' ? grid.getAttribute('data-view') : queued;
        if (view === current) return;

        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          window.clearTimeout(timer);
          queued = view;
          phase = 'idle';
          grid.classList.remove('is-fading');
          applyView(view);
          return;
        }

        queued = view;
        if (phase === 'idle') startFadeOut();
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
